<template>
    <label :for="item.data.id" :class="cssClass">
        <span class="origin">
            {{ item.data.question }} <span v-if="item.data.mandatory" class="mandatory">*</span>
        </span>
        <span v-if="isInvalid" class="error">{{ errorMessage }}</span>
    </label>
</template>

<script>
export default {
    name: 'Label',
    props: {
        item: {
            type: Object
        },
        isInvalid: {
            type: Boolean
        },
        errors: {
            type: Object
        },
        cssClass: {
            type: String
        },
        errorMessage: {
            type: String,
            default: ''
        }
    }
};
</script>